<template>
  <div class="flex flex-col gap-y-3 overflow-y-auto pr-2">
    <ul class="flex gap-x-3 items-center">
      <strong>{{ state.model?.name }}</strong>
      <text>{{ state.model?.number }}</text>
      <c_cell title="采购总额">
        <template #default>
          <c_money
            :key="state.model?.amount"
            :value="state.model?.amount"
            color="#1e90ff"
          />
        </template>
      </c_cell>
      <c_cell title="已收">
        <template #default>
          <c_money
            :key="state.model?.paid_amount"
            :value="state.model?.paid_amount"
            color="#080"
          />
        </template>
      </c_cell>
      <c_cell title="欠款">
        <template #default>
          <c_money
            :key="state.model?.unpaid_amount"
            :value="state.model?.unpaid_amount"
            :size="20"
            bold
          />
        </template>
      </c_cell>
    </ul>
    <ul class="flex gap-x-3">
      <c_cell title="采购类型" :value="state.model?.d_cost_type_pname" />
    </ul>
    <c_cell title="所属会议">
      <template #default>
        <div class="flex items-center gap-x-3">
          <text>{{ state.model?.meeting?.name }}</text>
          <text class="text-xs text-gray-400">
            {{ state.model?.meeting?.number }}
          </text>
          <text class="text-xs">{{
            state.model?.meeting?.start_date +
            " ~ " +
            state.model?.meeting?.end_date
          }}</text>
          <c_status
            arrName="Meeting_Status"
            :value="state.model?.meeting?.status"
            :key="state.model?.meeting?.status"
            showBg
          />
        </div>
      </template>
    </c_cell>
    <c_cell title="采购说明" :value="state.model?.intro" />
    <c_cell title="附件">
      <template #default>
        <c_UploadFile
          v-if="state.model?.attachment?.length > 0"
          :key="state.model?.attachment"
          :value="state.model?.attachment"
          :showAdd="false"
          :showText="true"
        />
        <text v-else>-</text>
      </template>
    </c_cell>
    <strong>采购明细</strong>
    <div>
      <el-table
        :data="state.model?.meetingPurchaseItemList"
        v-loading="!Array.isArray(state.model?.meetingPurchaseItemList)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        height="auto"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          align="center"
        />
        <el-table-column label="类型" :width="160" prop="d_cost_type_name" />
        <el-table-column :min-width="140">
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="规格" />
          </template>
          <template #default="{ row }">
            <text>{{ row.name }}</text>
            <text class="text-gray-400 text-xs">{{ row.specification }}</text>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="采购单价" label2="单位" />
          </template>
          <template #default="{ row }">
            <text>{{ $priceFormat(row.price) }}</text>
            <text class="text-gray-400 text-xs">{{
              "/" + row.d_measure_unit_name
            }}</text>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="采购数量" label2="天数" />
          </template>
          <template #default="{ row }">
            <text>{{ row.count }}</text>
            <text class="text-gray-400 text-xs">{{
              "/" + (row.day_count || "-")
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          prop="remark"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="采购金额"
          prop="amount"
          :formatter="$tab_MoneyFormat"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { supplier_purchase_search } from "@/http/supplier";
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      if (props.id) {
        supplier_purchase_search(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data || [];
          }
        });
      }
    });

    return { state };
  },
};
</script>
<style scoped></style>
